import { noDataCopy } from '../../constants/constants';
import { nudosTextcolor } from '../../styles/styles.constants';
import { LOCATION_PLACE_TYPE } from '../../types/services';
import { getLocationIcon } from '../../views/LogisticServices/utils/general.utils';
import { NudosHoverText } from '../NudosComponents';
import { TcountryCode } from '../NudosComponents/BordFlag/BordFlag.types';
import BordPhoto from '../NudosComponents/BordPhoto/BordPhoto';
import './AssetLocationDisplay.scss';

/**
 * Componente para mostrar la ubicación de un activo con bandera/icono y nombre
 */
const AssetLocationDisplay = ({
  location,
  locationName,
  textCharactersLimit = 17,
  customClassName = '',
  customTextHoverClassName = ''
}: IAssetLocationDisplayProps) => {
  const { country = 'zz', place } = location || {};
  const iconVariant = getLocationIcon({ place: place as LOCATION_PLACE_TYPE });

  return (
    <div className={`assetLocationDisplay ${customClassName}`}>
      <BordPhoto
        variant="circle"
        size="s24"
        flagProps={{
          variant: 'square',
          customWidth: '12px',
          country: country as TcountryCode
        }}
        imageProps={{
          style: {
            borderRadius: '11px',
            objectFit: 'cover',
            height: '100%',
            width: '100%',
            objectPosition: 'center center'
          }
        }}
        oneToneIconProps={{
          variant: iconVariant,
          standardSize: 16,
          stroke: nudosTextcolor
        }}
      />
      <NudosHoverText
        onlyIfTruncated
        customClassName="locationName"
        customTextHoverClassName={customTextHoverClassName || 'locationTextHover'}
        text={locationName || noDataCopy}
        charactersLimit={textCharactersLimit}
      />
    </div>
  );
};

export default AssetLocationDisplay;

interface IAssetLocationDisplayLocation {
  country?: string;
  place: LOCATION_PLACE_TYPE;
}

interface IAssetLocationDisplayProps {
  location?: IAssetLocationDisplayLocation;
  locationName: string;
  textCharactersLimit?: number;
  customClassName?: string;
  customTextHoverClassName?: string;
}
